//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { addMonths } from 'date-fns'
import { formatDate } from '@/plugins/filters'

export default {
  name: 'CutlerySelectPage',

  layout: 'page',

  data() {
    return {
      date: addMonths(new Date(), 1),
      formLoading: false,
      floor: null,
      floors: null,
    }
  },

  computed: {
    month() {
      return formatDate(this.date, 'yyyy-MM')
    },
  },

  mounted() {
    this.fetchOptions()
  },

  methods: {
    async fetchOptions() {
      this.formLoading = true

      const res = await this.$axios.$get('/equipments/floors', {
        params: {
          month: this.month,
        },
      })

      this.formLoading = false

      const { floors } = res.data

      if (!floors?.length) {
        this.$router.push('/odg/cutlery')

        return
      }

      this.floors = floors
      this.floor = floors[0].id
    },
    save() {
      const floorItem = this.floors.find((item) => item.id === this.floor)

      if (floorItem.url) {
        return window.open(floorItem.url, '_blank')
      }

      this.$router.push({
        path: '/odg/cutlery',
        query: {
          floor: this.floor,
        },
      })
    },
  },
}
